module.exports = __webpack_public_path__ + "img/Dantam Hair 33.938c46c3.jpg";